<template>
  <el-tooltip
    :popper-class="{
      'popper-default': true,
      'ru-locale': $i18n.locale === 'ru'
    }"
    :auto-close="1000"
    :content="$t('coreCopied')"
    trigger="click"
    placement="top"
    :disabled="disabled"
  >
    <span
      class="copy-button-icon"
      :class="{
        'copy-button-icon-disabled': disabled
      }"
      @click="copy"
    >
      <el-tooltip
        trigger="hover"
        :content="$t('coreCopy')"
        :popper-class="{
          'popper-default': true,
          'ru-locale': $i18n.locale === 'ru'
        }"
        placement="top"
        :auto-close="1000"
        :disabled="disabled"
      >
        <Copy />
      </el-tooltip>
    </span>
  </el-tooltip>
</template>

<script setup lang="ts">
import Copy from '~/components/icons/Copy.vue';

const props = defineProps<{
  copyValue: string;
  disabled?: boolean;
}>();

const { copy } = useCopyClipboard(toRef(() => props.copyValue));
</script>

<style lang="scss">
.el-tooltip__trigger.copy-button-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 30px;
  width: 30px;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.copy-button-icon-disabled {
  opacity: 0.5;
}
</style>
